import PageSlug from './PageSlug';
export default PageSlug;
